<template>
	<card class="guideline-job-form">
		<h3 class="tw-mb-2">Agrega todos los puestos de TRABAJO DE  tu empresa</h3>
		<form class='job-form' @submit="addJob">
			<v-text-field
				label="Puesto de trabajo"
				solo
				hide-details
				class="input-text"
				v-model="jobName"
			></v-text-field>
			<v-btn class="custom-button" color="primary" fab type="submit" :disabled='disabledAddButton'>
				<v-icon>add</v-icon>
			</v-btn>
		</form>
		<v-snackbar
			v-model="showMessage"
			:bottom="true"
		>
			{{ message }}
		</v-snackbar>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import { any, propEq, isEmpty } from 'ramda';

const INPUT_MAX_LENGTH = '60';

export default {
	name: 'guideline-job-form',
	components: { Card },
	props: ['jobList', 'maxJobsList'],
	data() {
		return {
			jobName: '',
			showMessage: false,
			message: '',
		};
	},
	mounted() {
		const input = document.querySelector('.job-form input');
		input.setAttribute('maxLength', INPUT_MAX_LENGTH);
	},
	computed: {
		disabledAddButton() {
			return isEmpty(this.jobName) || this.jobList.length === this.maxJobsList;
		},
	},
	methods: {
		addJob(event) {
			event.preventDefault();
			if (this.itemExists(this.jobName)) {
				this.showMessageSnacker('Ya existe un puesto con ese nombre.');
				return;
			}
			this.$emit('jobAdded', this.jobName);
			this.jobName = '';
		},
		itemExists(jobName) {
			return any(propEq('name', jobName), this.jobList);
		},
		showMessageSnacker(message) {
			this.message = message;
			this.showMessage = true;
			setTimeout(() => { this.showMessage = false; }, 6000);
		},
	},
};
</script>

<style lang='scss' scoped>
.guideline-job-form {
	h3 {
		text-transform: uppercase;
		font-size: 12px;
		color: var(--app-color-primary);
	}
	.job-form {
		position: relative;
		.v-input {
			width: calc(100% - 50px);
		}
		.v-btn {
			position: absolute;
			top: 0;
			right: 0;
			width: 40px !important;
			border-radius: 8px !important;
			.v-icon {
				color: white !important;
				padding-top: 5px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-form.vue